function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.2 6H25.8C26.9139 6 27.9822 6.4425 28.7698 7.23015C29.5575 8.0178 30 9.08609 30 10.2V21.4C30 22.5139 29.5575 23.5822 28.7698 24.3699C27.9822 25.1575 26.9139 25.6 25.8 25.6H6.2C5.08609 25.6 4.0178 25.1575 3.23015 24.3699C2.4425 23.5822 2 22.5139 2 21.4V10.2C2 9.08609 2.4425 8.0178 3.23015 7.23015C4.0178 6.4425 5.08609 6 6.2 6V6ZM6.2 14.4V17.2H9V14.4H6.2ZM6.2 10.2V13H9V10.2H6.2ZM6.2 18.6V21.4H9V18.6H6.2ZM10.4 18.6V21.4H21.6V18.6H10.4ZM10.4 14.4V17.2H13.2V14.4H10.4ZM10.4 10.2V13H13.2V10.2H10.4ZM14.6 14.4V17.2H17.4V14.4H14.6ZM14.6 10.2V13H17.4V10.2H14.6ZM23 18.6V21.4H25.8V18.6H23ZM18.8 14.4V17.2H21.6V14.4H18.8ZM18.8 10.2V13H21.6V10.2H18.8ZM23 10.2V17.2H25.8V10.2H23Z"
});

function SvgIcKeyboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeyboard);
export default ForwardRef;